import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_ctx.storeLocation.displayStatus && !!_ctx.storeLocation.displayStatus.status)
    ? (_openBlock(), _createBlock(_component_ion_row, {
        key: 0,
        class: "mb-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_badge, {
            color: _ctx.storeLocation.displayStatus.toColor
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.storeLocation.displayStatus.toString), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}